// extracted by mini-css-extract-plugin
export default {"CreditCards":"gZY87Chc","Loading":"Abl7Ksog"};